import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styles from './TradingHistoryLoader.module.css';

const DocLoader = () => (
  <div className={styles.docLoader}>
    <div className={styles.textLoader}>
      <Skeleton className={styles.requirement} width="50%" />
      <Skeleton className={styles.requirement} />
      <Skeleton width="80%" />
    </div>
    <div className={styles.button}>
      <Skeleton width={120} height={50} />
    </div>
  </div>
);

const LoanPurposeDetailsLoader = () => (
  <div className={styles.docLoader}>
    <div className={styles.textLoader}>
      <Skeleton className={styles.requirement} width="50%" />
      <Skeleton className={styles.requirement} />
      <Skeleton height={120} width="100%" />
    </div>
  </div>
);

export const TradingHistoryLoader = () => {
  return (
    <>
      <section className={styles.loaderContainer}>
        <LoanPurposeDetailsLoader />
      </section>
      <section className={styles.loaderContainer}>
        <div className={styles.docLoaderContainer}>
          <DocLoader />
        </div>
        <div className={styles.docLoaderContainer}>
          <DocLoader />
        </div>
        <div className={styles.docLoaderContainer}>
          <DocLoader />
        </div>
      </section>
    </>
  );
};
